import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 600px;
  height: 100%;

  .react-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .react-tabs__tab-panel {
    max-height: calc(100vh - 312px);
    overflow: auto;
    padding-bottom: 4px;
  }

  .tab-text {
    margin: 0;
  }
`;
export const TabWrapper = styled.div`
  .react-tabs__tab-panel {
    min-height: 180px;
  }

  .react-tabs__tab-list {
    padding: 6px 6px 2px 6px !important;
    background: var(--grey-100);
    margin: 0 !important;
  }

  .react-tabs__tab {
    color: var(--primary-500);
  }

  .react-tabs__tab--selected {
    font-weight: 600;
    border-radius: 4px 4px 0 0 !important;
  }
`;

export const ModalFooter = styled(Flex)`
  border-top: solid var(--grey-300) 1px;
  padding: 0.4rem;
`;
